import { c as _c } from "react/compiler-runtime";
import { IcoSparkles16 } from '@onefootprint/icons';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const SWEEP_DURATION = 1.1;
// When each message appears, in seconds. Document verification and AI decision nodes hold the flow
// for up to 18 s and 30 s, so later messages come slower and never promise an end.
const MESSAGE_STARTS = [0, 3, 6, 10, 16, 24];
export const LoadingFallback = () => {
  const $ = _c(28);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "loadingFallback"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = [t1, t2, t3, t4, t5, t6];
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const messages = t7;
  const [index, setIndex] = useState(0);
  let t8;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const timers = MESSAGE_STARTS.slice(1).map((seconds, i) => setTimeout(() => setIndex(i + 1), seconds * 1000));
      return () => timers.forEach(clearTimeout);
    };
    t9 = [];
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <motion.span className="inline-flex" animate={{
      scale: [1, 0.85, 1]
    }} transition={{
      duration: SWEEP_DURATION * 0.8,
      repeat: Infinity,
      ease: "easeInOut"
    }}><IcoSparkles16 color="primary" /></motion.span>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      backgroundPosition: ["100% center", "0% center"]
    };
    t12 = {
      duration: SWEEP_DURATION,
      repeat: Infinity,
      repeatType: "mirror",
      ease: "easeInOut"
    };
    t13 = {
      backgroundImage: "linear-gradient(90deg, currentColor 0%, rgb(160,160,160) 50%, currentColor 100%)",
      WebkitTextFillColor: "transparent"
    };
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
  }
  const t14 = messages[index];
  let t15;
  if ($[26] !== t14) {
    t15 = <div className="flex h-full min-h-(--loading-container-min-height) items-center justify-center"><div className="flex items-center gap-2">{t10}<motion.span className="text-label-2 bg-clip-text [background-size:300%_100%]" animate={t11} transition={t12} style={t13}>{t14}</motion.span></div></div>;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};
function _temp($) {
  return $.processing;
}
function _temp2($_0) {
  return $_0.reviewing;
}
function _temp3($_1) {
  return $_1.verifying;
}
function _temp4($_2) {
  return $_2.reviewingResults;
}
function _temp5($_3) {
  return $_3.stillWorking;
}
function _temp6($_4) {
  return $_4.mayTakeAMinute;
}